import { render, staticRenderFns } from "./editPatient.vue?vue&type=template&id=3f528100&"
import script from "./editPatient.vue?vue&type=script&lang=js&"
export * from "./editPatient.vue?vue&type=script&lang=js&"
import style0 from "./editPatient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports